var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-white fixed-top d-flex align-items-center justify-content-center mx-auto py-3 px-3 mt-3",attrs:{"feedback-alert":""}},[_vm._m(0),_vm._v(" "),_c('h2',{staticClass:"feedback-text mb-0"},[_vm._v(_vm._s(_vm.getInteractionFeedbackText()))]),_vm._v(" "),_c('div')])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"feedback-icon mr-3"},[_c('i',{staticClass:"fas fa-thumbs-up"})])
}]

export { render, staticRenderFns }